import React from 'react';
import {Checkbox, CheckboxProps, FormControlLabel, FormHelperText} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import {StyledP2} from "../ui-base/styles";
import {FormControl, Grid, Tooltip} from "@mui/material";
import {HelpOutlineOutlined} from "@material-ui/icons";

const StyleCheckbox = withStyles({
    root: {
        color: '#C8CCD0',
        '&$checked': {
            color: '#FF9C00 !important',
        },
        '&.checkbox-error': {
            color: '#7D1C24'
        }
    },
    checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

export const StyledCheckbox: React.FC<StyledCheckboxProps> = ({id, name, onChange, value, label, onClick, className, error, errorMessage, tooltipInfo = ''}) => {

    return (
        <FormControl>
            <FormControlLabel
                style={{marginLeft: '-11px', marginRight: 0}}
                control={
                    <StyleCheckbox
                        className={className}
                        style={{color: (error) ? '#7D1C24' : '#C8CCD0'}}
                        checked={value}
                        onChange={onChange}
                        name={name}
                        id={id}
                        onClick={(e) => {
                            if (onClick) {
                                onClick(e);
                            }
                        }}
                    />
                }
                label={
                <Grid container direction={'row'} alignItems="center">
                    <StyledP2>
                        {label}
                    </StyledP2>
                    {tooltipInfo &&
                        <Tooltip title={tooltipInfo}>
                            <HelpOutlineOutlined style={{color: 'rgba(0, 0, 0, 0.5)'}}/>
                        </Tooltip>
                    }
                </Grid>
                }
            />
            {error && errorMessage &&
                <FormHelperText style={{color: '#DB575F'}}>
                    {errorMessage}
                </FormHelperText>
            }
        </FormControl>
    );
}

interface StyledCheckboxProps {
    id: string,
    name: string,
    onChange: any,
    value: any,
    label: string | Element,
    onClick?: any,
    className?: string,
    error?: boolean,
    errorMessage?: string,
    tooltipInfo?: string
}
